import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6b736c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-cbx self-center" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z" }),
    /*#__PURE__*/_createElementVNode("polyline", { points: "4 11 8 15 16 6" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      class: "cbx invisible",
      type: "checkbox",
      checked: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.checked)))
    }, null, 40, _hoisted_2),
    _hoisted_3
  ]))
}